import React from 'react';
import SymbolIcon from '../unit/dice/SymbolIcon.js';
export default function BonusSymbolAsImage({ size, symbol, }) {
    const padding = size / 10;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size },
        React.createElement(SymbolIcon, { symbol: symbol, size: size - padding, origin: { x: padding / 2, y: padding / 2 } })));
}
